export default '/build/331065e4.svg'